/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

/**
 * A JSON object containing feature names and their values.
 */

// additional attributes

export const FeatureFlagsResponse = t.record(
  t.string,
  t.any,
  "FeatureFlagsResponse"
);

export type FeatureFlagsResponse = t.TypeOf<typeof FeatureFlagsResponse>;
